module.exports = __webpack_public_path__ + "static/img/alsj_02.ca9bf15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alsj_02.jpg
// module id = 0rZG
// module chunks = 1